/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Type_TimingInputs */

const en_manual_qc_type_timing = /** @type {(inputs: Manual_Qc_Type_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing Issue`)
};

const fr_manual_qc_type_timing = /** @type {(inputs: Manual_Qc_Type_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probleme de timing`)
};

const de_manual_qc_type_timing = /** @type {(inputs: Manual_Qc_Type_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing-Problem`)
};

const it_manual_qc_type_timing = /** @type {(inputs: Manual_Qc_Type_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema di tempistica`)
};

const ru_manual_qc_type_timing = /** @type {(inputs: Manual_Qc_Type_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проблема со временем`)
};

const es_manual_qc_type_timing = /** @type {(inputs: Manual_Qc_Type_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema de tiempo`)
};

const zh_cn2_manual_qc_type_timing = /** @type {(inputs: Manual_Qc_Type_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时序问题`)
};

const ja_manual_qc_type_timing = /** @type {(inputs: Manual_Qc_Type_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイミングの問題`)
};

const hi_manual_qc_type_timing = /** @type {(inputs: Manual_Qc_Type_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय संबंधी समस्या`)
};

const pt_pt2_manual_qc_type_timing = /** @type {(inputs: Manual_Qc_Type_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema de sincronização`)
};

/**
* | output |
* | --- |
* | "Timing Issue" |
*
* @param {Manual_Qc_Type_TimingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_type_timing = /** @type {((inputs?: Manual_Qc_Type_TimingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Type_TimingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_type_timing(inputs)
	if (locale === "de") return de_manual_qc_type_timing(inputs)
	if (locale === "it") return it_manual_qc_type_timing(inputs)
	if (locale === "ru") return ru_manual_qc_type_timing(inputs)
	if (locale === "es") return es_manual_qc_type_timing(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_type_timing(inputs)
	if (locale === "ja") return ja_manual_qc_type_timing(inputs)
	if (locale === "hi") return hi_manual_qc_type_timing(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_type_timing(inputs)
	return en_manual_qc_type_timing(inputs)
});